export const styles = {
  mainStack: {
    minWidth: 0,
    maxWidth: "100%",
    width: "auto",
    alignItems: "flex-start",
    gap: 1,
  },
  textStack: {
    alignSelf: "stretch",
    alignItems: "center",
  },
  text: (boldText) => ({
    height: "100%",
    display: "flex",
    alignItems: "center",
    textAlign: "left",
    maxWidth: "100%",
    overflowWrap: "anywhere",
    wordBreak: "break-word",
    whiteSpace: "pre-line",
    fontWeight: boldText ? "bold" : "normal",
  }),
};
